








import Vue from 'vue';
import i18n from '@/web/utils/localization';

export default Vue.extend({
  props: {
    isActive: Boolean,
    activleLabel: {
      type: String,
      default: i18n.t('CUSTOMERS.LABEL.ACTIVE'),
    },
    inactiveLabel: {
      type: String,
      default: i18n.t('CUSTOMERS.LABEL.INACTIVE'),
    },
  },
});
